// import React, { useEffect, useRef, useState } from "react";
// import {
//   MapPin,
//   Ruler,
//   Droplet,
//   BadgeCheck,
//   Building,
//   CheckCircle,
//   Gavel,
//   Map,
//   FileCheck,
//   Landmark,
//   X
// } from "lucide-react";
// import { useLocation, useNavigate } from "react-router-dom";
// import api from "../common/apiClient";
// import SummaryApi from "../common/SummaryApi";
// import RequestVisitModal from "../components/RequestVisitModal";


// const PropertyOverview = () => {
//   const [data, setData] = useState(null);
//   const [openDoc, setOpenDoc] = useState(null);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const id = location.state?.id || location.state;
//   const [openModal, setOpenModal] = useState(false);
//   const [similarProps, setSimilarProps] = useState([]);
//   const handleScrollToGallery = () => {
//     galleryRef.current?.scrollIntoView({ behavior: "smooth" });
//   };

//   const galleryRef = useRef(null);
  
//   useEffect(() => {
//     const fetchProperty = async () => {
//       if (!id) return;

//       try {
//         const res = await api({
//           url: SummaryApi.getOneProperty.url(id),
//           method: SummaryApi.getOneProperty.method,
//         });

//         // ✅ direct set (no mapping)
//         setData(res.data?.data);

//       } catch (err) {
//         console.error("Fetch one property error:", err);
//       }
//     };

//     if (id) {
//       fetchProperty();
//     }
  
//   }, [id]);

//   useEffect(() => {
//     const fetchSimilar = async () => {
//       if (!data?.category) return;

//       try {
//         const res = await api({
//           url: SummaryApi.getAllProperties.url,
//           method: SummaryApi.getAllProperties.method,
//         });

//         const all = res.data?.data || [];

//         const filtered = all
//           .filter(
//             (p) =>
//               p.category?.trim() === data.category?.trim() && // same category
//               p._id !== data._id // ❌ current property remove
//           )
//           .slice(0, 3) // only 3

//           .map((p) => ({
//             id: p._id,
//             title: p.title,
//             location: p.location,
//             size: p.landSize,
//             image:
//               p.heroImage?.url ||
//               p.gallery?.[0]?.url,
//           }));

//         setSimilarProps(filtered);

//       } catch (err) {
//         console.error("Similar fetch error:", err);
//       }
//     };

//     fetchSimilar();
//   }, [data]);

//   if (!data) return <p className="p-10">Loading...</p>;

//   const stats = [
//     { icon: MapPin, title: "Location", value: data.location },
//     { icon: Ruler, title: "Land Size", value: data.landSize },
//     { icon: Building, title: "Price", value: data.pricing },
//     { icon: Building, title: "Road Access", value: data.roadAccess },
//     { icon: Droplet, title: "Water Source", value: data.waterSource },
//     { icon: BadgeCheck, title: "Legal Status", value: data.legalStatus },
//   ];

//   return (
//     <div className="container mx-auto py-10 px-6">
//       <div className="">

//         {/* HERO IMAGE */}
//         <div className="relative rounded-xl overflow-hidden">
//         <img
//           src={
//             data.heroImage?.url ||
//             data.gallery?.[0]?.url
//           }
//           alt={data.title}
//           className="w-full h-[260px] md:h-[460px] object-cover"
//         />

//           <div className="absolute bottom-6 left-6 text-white">
//             <h1 className="text-2xl md:text-3xl font-times">
//               {data.title}
//             </h1>
//             <p className="text-sm opacity-90">
//               {data.location}
//             </p>
//           </div>
//         </div>

//         {/* GALLERY */}
//         <div className="grid grid-cols-3 gap-3 mt-4">
//           {data.gallery?.slice(0, 3).map((img, i) => {
//             const total = data.gallery.length;

//             // 👉 last image & more than 3 இருந்தா மட்டும் overlay
//             const showOverlay = i === 2 && total > 3;

//             return (
//               <div key={i} className="relative cursor-pointer">
//                 <img
//                   src={img.url}
//                   alt={data.title}
//                   className="rounded-lg h-36 md:h-60 object-cover w-full"
//                   onClick={handleScrollToGallery}
//                 />

//                 {showOverlay && (
//                   <div
//                     onClick={handleScrollToGallery}
//                     className="absolute inset-0 bg-black/50 flex items-center justify-center rounded-lg"
//                   >
//                     <p className="text-white text-lg font-semibold">
//                       +{total - 3} Photos
//                     </p>
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//         {/* <div ref={galleryRef} className="mt-10">
//           <h2 className="text-xl font-times mb-4">All Photos</h2>

//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//             {data.gallery?.map((img, i) => (
//               <img
//                 key={i}
//                 src={img.url}
//                 alt="gallery"
//                 className="rounded-lg object-cover w-full h-40"
//               />
//             ))}
//           </div>
//         </div> */}
//         {/* STATS */}
//         <div className="bg-white rounded-lg mt-6">
//           <div className="hidden md:grid grid-cols-6 text-center py-5">
//             {stats.map((item, i) => (
//               <div key={i} className="flex flex-col items-center gap-1">
//                 <item.icon size={20} className="text-[#45A301]" />
//                 <p className="text-sm text-[#94A3B8]">{item.title}</p>
//                 <p className="text-base text-[#1E293B] font-semibold">{item.value || "-"}</p>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* OVERVIEW + RIGHT */}
//         <div className="grid md:grid-cols-3 gap-10 mt-10">

//           {/* LEFT */}
//           <div className="md:col-span-2">

//             <p className="text-xs text-[#45A301] uppercase mb-2">
//               Land Details
//             </p>

//             <h2 className="text-2xl font-times mb-4">
//               Land Overview
//             </h2>

//             <p className="text-gray-600 leading-relaxed mb-4">
//               {data.overview}
//             </p>

//             {/* LAND SPEC */}
//             {(data.soilType || data.elevation || data.crops || data.yield || data.rainfall) && (
//               <>
//                 <h2 className="text-2xl font-times mt-10 mb-6">
//                   Land Specifications
//                 </h2>

//                 <div className="bg-white rounded-lg p-8">
//                   <div className="grid md:grid-cols-2 gap-x-16 gap-y-8">

//                     <Spec label="Soil Type" value={data.soilType} />
//                     <Spec label="Elevation" value={data.elevation} />
//                     <Spec label="Primary Crop" value={data.crops} />
//                     <Spec label="Secondary Crop" value={data.secondaryCrops} />
//                     <Spec label="Average Yield" value={data.yield} />
//                     <Spec label="Rainfall" value={data.rainfall} />

//                   </div>
//                 </div>
//               </>
//             )}



//           </div>

//           {/* RIGHT */}
//           <div>

//             {/* ACTION BOX */}
//             <div className="bg-white rounded-2xl p-6 shadow-sm mb-6">

//               <button
//                 onClick={() => setOpenModal(true)}
//                 disabled={!data?.enableVisit}
//                 className={`w-full py-2.5 rounded-lg mb-3 text-white transition 
//                   ${
//                     data?.enableVisit
//                       ? "bg-[#45A301] hover:bg-[#3a8a01]"
//                       : "bg-gray-300 cursor-not-allowed"
//                   }`}
//               >
//                 Request Site Visit
//               </button>

//               <button className="w-full border py-3 rounded-lg mb-5">
//                 WhatsApp
//               </button>

//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-gray-300"></div>
//                 <div>
//                   <p className="text-sm font-medium">Rajkumar</p>
//                   <p className="text-xs text-gray-400">
//                     Certified Estate Manager
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* DOCUMENTS */}
//             <div>
//               <h2 className="text-xl font-times mb-4">Documents</h2>

//               <div className="bg-white rounded-xl shadow-sm">

//                 {Object.entries(data.documents || {}).map(([key, value], i) => (
//                   value && (
//                     <div
//                       key={i}
//                       className="flex justify-between items-center px-4 py-3 border-b last:border-none"
//                     >
//                       <p className="text-sm">
//                         {value}
//                       </p>

//                       <button
//                         onClick={() => setOpenDoc(value)}
//                         className="text-[#45A301] text-sm"
//                       >
//                         View
//                       </button>
//                     </div>
//                   )
//                 ))}

//               </div>
//             </div>

//           </div>
//         </div>
//             {/* FEATURES */}
//             <div className="mt-10">
//               <h2 className="text-xl font-times mb-4">
//                 Key Land Features
//               </h2>

//               <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4 text-gray-600 text-sm">
//                 {data.features?.map((f, i) => (
//                   <div key={i} className="flex gap-2">
//                     <CheckCircle className="text-[#45A301]" size={18} />
//                     {f}
//                   </div>
//                 ))}
//               </div>
//             </div>

//         {similarProps.length > 0 && (
//           <div className="mt-20">
            
//             {/* Heading */}
//             <div className="flex justify-between items-center mb-6">
//               <div>
//                 <h2 className="text-2xl font-times">Similar Estates</h2>
//                 <p className="text-sm mt-2 text-[#64748B]">
//                   Explore other similar land options
//                 </p>
//               </div>

//               <button
//                 onClick={() =>
//                   navigate(`/properties?category=${data.category.replace(/\s+/g, "-")}`)
//                 }
//                 className="text-sm text-[#45A301]"
//               >
//                 View All
//               </button>
//             </div>

//             {/* Cards */}
//             <div className="lg:px-12 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-8 w-full">
//               {similarProps.map((item) => (
//                 <div key={item.id} className="cursor-pointer group">

//                   <div className="rounded-xl overflow-hidden">
//                     <img
//                       src={item.image}
//                       alt={item.title}
//                       className="h-60 w-full object-cover group-hover:scale-105 transition"
//                     />
//                   </div>

//                   <h3 className="mt-3 text-lg font-medium font-times text-[#0F172A]">
//                     {item.title}
//                   </h3>

//                   <p className="text-sm text-[#64748B] mt-2">
//                     {item.location}, {item.size}
//                   </p>

//                 </div>
//               ))}
//             </div>

//           </div>
//         )}

//         {/* LAND DOCUMENT VERIFICATION (STATIC) */}
//         <div className="mt-16 bg-white rounded-2xl p-8 md:p-10">

//           <h2 className="text-2xl font-times text-center mb-2">
//             Land Document Verification
//           </h2>

//           <p className="text-[#64748B] text-center mb-10 max-w-2xl mx-auto">
//             Every land parcel in our portfolio undergoes a rigorous 42-point legal and
//             technical audit by our in-house panel of estate experts.
//           </p>

//           <div className="space-y-6 md:space-y-0 md:grid grid-cols-4 gap-8 text-center">

//             <div className="flex flex-col items-center">
//               <Gavel className="text-[#45A301] mb-3" size={28} />
//               <p className="font-medium">Legal Land Audit</p>
//               <p className="text-xs max-w-[150px] mt-1 font-medium text-[#94A3B8]">Clear title deed history checked back for 30 years.</p>
//             </div>

//             <div className="flex flex-col items-center">
//               <Map className="text-[#45A301] mb-3" size={28} />
//               <p className="font-medium">Land Survey</p>
//               <p className="text-xs max-w-[150px] mt-1 font-medium text-[#94A3B8]">Physical boundary mapping using DGPS technology.</p>
//             </div>

//             <div className="flex flex-col items-center">
//               <FileCheck className="text-[#45A301] mb-3" size={28} />
//               <p className="font-medium">Pattayam Verify</p>
//               <p className="text-xs max-w-[150px] mt-1 font-medium text-[#94A3B8]">Direct verification from Village & Taluk offices.</p>
//             </div>

//             <div className="flex flex-col items-center">
//               <Landmark className="text-[#45A301] mb-3" size={28} />
//               <p className="font-medium">Tax Status</p>
//               <p className="text-xs max-w-[150px] mt-1 font-medium text-[#94A3B8]">Physical boundary mapping using DGPS technology.</p>
//             </div>

//           </div>
//         </div>

//         {/* MODAL */}
//         {openDoc && (
//           <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">

//             <div className="bg-white rounded-xl p-6 w-[90%] max-w-md relative">

//               <button
//                 onClick={() => setOpenDoc(null)}
//                 className="absolute top-3 right-3"
//               >
//                 <X />
//               </button>

//               <h3 className="text-lg font-semibold mb-3">
//                 Document Preview
//               </h3>

//               <p className="text-gray-600 text-sm">
//                 {openDoc}
//               </p>

//             </div>
//           </div>
//         )}

//       </div>
//       <RequestVisitModal
//         open={openModal}
//         onClose={() => setOpenModal(false)}
//         propertyId={data?._id}
//       />
//     </div>
//   );
// };

// export default PropertyOverview;

// function Spec({ label, value }) {
//   if (!value) return null; // ❗ value 

//   return (
//     <div className="border-b pb-3">
//       <p className="text-sm text-gray-400 mb-1">{label}</p>
//       <p className="text-lg font-medium text-gray-800">
//         {value}
//       </p>
//     </div>
//   );
// }



import React, { useEffect, useRef, useState } from "react";
import {
  MapPin,
  Ruler,
  Droplet,
  BadgeCheck,
  Building,
  CheckCircle,
  Gavel,
  Map,
  FileCheck,
  Landmark,
  X,
  MessageCircle // Added for WhatsApp icon look if needed
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../common/apiClient";
import SummaryApi from "../common/SummaryApi";
import RequestVisitModal from "../components/RequestVisitModal";

const PropertyOverview = () => {
  const [data, setData] = useState(null);
  const [openDoc, setOpenDoc] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id || location.state || location.pathname.split("/").pop(); // Try to get ID from state or URL
  const [openModal, setOpenModal] = useState(false);
  const [similarProps, setSimilarProps] = useState([]);
  
  const galleryRef = useRef(null);

  const handleScrollToGallery = () => {
    galleryRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // 🔥 WhatsApp Integration Logic
  const handleWhatsApp = () => {
    const phoneNumber = "918946059070"; // The contact number from your records
    const currentUrl = window.location.href;
    
    const message = `Hello KL Property, I am interested in this property:
*Property:* ${data?.title}
*Location:* ${data?.location}
*Size:* ${data?.landSize}
*Price:* ${data?.pricing}
*Link:* ${currentUrl}`;

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  useEffect(() => {
    const fetchProperty = async () => {
      if (!id) return;

      try {
        const res = await api({
          url: SummaryApi.getOneProperty.url(id),
          method: SummaryApi.getOneProperty.method,
        });

        setData(res.data?.data);
      } catch (err) {
        console.error("Fetch one property error:", err);
      }
    };

    if (id) {
      fetchProperty();
    }
  }, [id]);

  useEffect(() => {
    const fetchSimilar = async () => {
      if (!data?.category) return;

      try {
        const res = await api({
          url: SummaryApi.getAllProperties.url,
          method: SummaryApi.getAllProperties.method,
        });

        const all = res.data?.data || [];

        const filtered = all
          .filter(
            (p) =>
              p.category?.trim() === data.category?.trim() && 
              p._id !== data._id 
          )
          .slice(0, 3) 
          .map((p) => ({
            id: p._id,
            title: p.title,
            location: p.location,
            size: p.landSize,
            image: p.heroImage?.url || p.gallery?.[0]?.url,
          }));

        setSimilarProps(filtered);
      } catch (err) {
        console.error("Similar fetch error:", err);
      }
    };

    fetchSimilar();
  }, [data]);

  if (!data) return <p className="p-10">Loading...</p>;

  const stats = [
    { icon: MapPin, title: "Location", value: data.location },
    { icon: Ruler, title: "Land Size", value: data.landSize },
    { icon: Building, title: "Price", value: data.pricing },
    { icon: Building, title: "Road Access", value: data.roadAccess },
    { icon: Droplet, title: "Water Source", value: data.waterSource },
    { icon: BadgeCheck, title: "Legal Status", value: data.legalStatus },
  ];

  return (
    <div className="container mx-auto py-10 px-6">
      <div className="">
        {/* HERO IMAGE */}
        <div className="relative rounded-xl overflow-hidden shadow-lg">
          <img
            src={data.heroImage?.url || data.gallery?.[0]?.url}
            alt={data.title}
            className="w-full h-[260px] md:h-[460px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
          <div className="absolute bottom-6 left-6 text-white">
            <h1 className="text-2xl md:text-3xl font-times">{data.title}</h1>
            <p className="text-sm opacity-90 flex items-center gap-1">
              <MapPin size={14} /> {data.location}
            </p>
          </div>
        </div>

        {/* GALLERY PREVIEW */}
        <div className="grid grid-cols-3 gap-3 mt-4">
          {data.gallery?.slice(0, 3).map((img, i) => {
            const total = data.gallery.length;
            const showOverlay = i === 2 && total > 3;

            return (
              <div key={i} className="relative cursor-pointer group overflow-hidden rounded-lg">
                <img
                  src={img.url}
                  alt={data.title}
                  className="rounded-lg h-36 md:h-60 object-cover w-full group-hover:scale-105 transition duration-500"
                  onClick={handleScrollToGallery}
                />
                {showOverlay && (
                  <div
                    onClick={handleScrollToGallery}
                    className="absolute inset-0 bg-black/50 flex items-center justify-center rounded-lg"
                  >
                    <p className="text-white text-lg font-semibold">+{total - 3} Photos</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* STATS STRIP */}
        <div className="bg-white rounded-lg mt-6 shadow-sm border">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 text-center py-5 gap-y-6">
            {stats.map((item, i) => (
              <div key={i} className="flex flex-col items-center gap-1 border-r last:border-none border-gray-100">
                <item.icon size={20} className="text-[#45A301]" />
                <p className="text-xs text-[#94A3B8] uppercase tracking-wider">{item.title}</p>
                <p className="text-sm md:text-base text-[#1E293B] font-semibold">{item.value || "-"}</p>
              </div>
            ))}
          </div>
        </div>

        {/* OVERVIEW + RIGHT CONTENT */}
        <div className="grid md:grid-cols-3 gap-10 mt-10">
          
          {/* LEFT COLUMN */}
          <div className="md:col-span-2">
            <p className="text-xs text-[#45A301] uppercase font-bold tracking-widest mb-2">Land Details</p>
            <h2 className="text-2xl font-times mb-4">Land Overview</h2>
            <p className="text-gray-600 leading-relaxed mb-8 whitespace-pre-line">
              {data.overview}
            </p>

            {/* LAND SPECIFICATIONS */}
            {(data.soilType || data.elevation || data.crops || data.yield || data.rainfall) && (
              <div className="mt-10">
                <h2 className="text-2xl font-times mb-6">Land Specifications</h2>
                <div className="bg-white rounded-xl p-8 border shadow-sm">
                  <div className="grid md:grid-cols-2 gap-x-16 gap-y-8">
                    <Spec label="Soil Type" value={data.soilType} />
                    <Spec label="Elevation" value={data.elevation} />
                    <Spec label="Primary Crop" value={data.crops} />
                    <Spec label="Secondary Crop" value={data.secondaryCrops} />
                    <Spec label="Average Yield" value={data.yield} />
                    <Spec label="Rainfall" value={data.rainfall} />
                  </div>
                </div>
              </div>
            )}

            {/* FEATURES GRID */}
            <div className="mt-12">
              <h2 className="text-xl font-times mb-6 underline decoration-[#45A301] underline-offset-8">
                Key Land Features
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-gray-600 text-sm">
                {data.features?.map((f, i) => (
                  <div key={i} className="flex items-center gap-3 bg-gray-50 p-3 rounded-lg">
                    <CheckCircle className="text-[#45A301]" size={18} />
                    <span className="font-medium">{f}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN (STICKY ACTIONS) */}
          <div className="relative">
            <div className="sticky top-24">
              {/* ACTION BOX */}
              <div className="bg-white rounded-2xl p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border mb-6">
                <button
                  onClick={() => setOpenModal(true)}
                  disabled={!data?.enableVisit}
                  className={`w-full py-3 rounded-lg mb-3 text-white font-bold transition shadow-md
                    ${data?.enableVisit
                        ? "bg-[#45A301] hover:bg-[#3a8a01]"
                        : "bg-gray-300 cursor-not-allowed"
                    }`}
                >
                  Request Site Visit
                </button>

                <button 
                  onClick={handleWhatsApp}
                  className="w-full border-2 border-[#45A301] text-[#45A301] py-3 rounded-lg mb-6 font-bold hover:bg-[#45A301] hover:text-white transition flex items-center justify-center gap-2"
                >
                  <MessageCircle size={20} />
                  WhatsApp Us
                </button>

                <div className="flex items-center gap-3 border-t pt-5">
                  <div className="w-12 h-12 rounded-full bg-[#eef2e6] flex items-center justify-center text-[#45A301] font-bold text-xl">
                    R
                  </div>
                  <div>
                    <p className="text-sm font-bold text-gray-800">Rajkumar</p>
                    <p className="text-xs text-gray-500 font-medium">Certified Estate Manager</p>
                  </div>
                </div>
              </div>

              {/* DOCUMENTS SECTION */}
              {Object.entries(data.documents || {}).length > 0 && <div>
                <h2 className="text-xl font-times mb-4">Verification Documents</h2>
                <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
                  {Object.entries(data.documents || {}).map(([key, value], i) => (
                    value && (
                      <div key={i} className="flex justify-between items-center px-4 py-4 border-b last:border-none hover:bg-gray-50">
                        <div className="flex items-center gap-2">
                          <FileCheck size={16} className="text-[#45A301]" />
                          <p className="text-sm font-medium text-gray-700">{value}</p>
                        </div>
                        <button
                          onClick={() => setOpenDoc(value)}
                          className="text-[#45A301] text-xs font-bold uppercase hover:underline"
                        >
                          View
                        </button>
                      </div>
                    )
                  ))}
                </div>
              </div>}
            </div>
          </div>
        </div>

        {/* FULL GALLERY SECTION */}
        { data.gallery?.length > 0 && <div ref={galleryRef} className="mt-20">
          <h2 className="text-2xl font-times mb-6">Property Gallery</h2>
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
            {data.gallery?.map((img, i) => (
              <img
                key={i}
                src={img.url}
                alt={`Property view ${i + 1}`}
                className="rounded-xl object-cover w-full shadow-sm hover:opacity-90 transition cursor-pointer"
              />
            ))}
          </div>
        </div>}

        {/* SIMILAR ESTATES */}
        {similarProps.length > 0 && (
          <div className="mt-24">
            <div className="flex justify-between items-end mb-8">
              <div>
                <h2 className="text-3xl font-times">Similar Estates</h2>
                <p className="text-[#64748B] mt-2">Explore other land options in this category</p>
              </div>
              <button
                onClick={() => navigate(`/properties?category=${data.category.replace(/\s+/g, "-")}`)}
                className="text-[#45A301] font-bold border-b-2 border-[#45A301] pb-1"
              >
                View All
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {similarProps.map((item) => (
                <div 
                  key={item.id} 
                  className="cursor-pointer group"
                  onClick={() => {
                    navigate(`/properties/overview/${item.id}`, { state: { id: item.id } });
                    window.scrollTo(0, 0);
                  }}
                >
                  <div className="rounded-xl overflow-hidden h-64 shadow-md">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="h-full w-full object-cover group-hover:scale-110 transition duration-700"
                    />
                  </div>
                  <h3 className="mt-4 text-xl font-bold font-times text-[#0F172A] group-hover:text-[#45A301] transition">
                    {item.title}
                  </h3>
                  <p className="text-sm text-[#64748B] mt-1 font-medium italic">
                    {item.location} • {item.size}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* LEGAL VERIFICATION SECTION */}
        <div className="mt-24 bg-[#f8fafc] rounded-3xl p-8 md:p-16 border border-gray-100">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-times mb-4">42-Point Verification Process</h2>
            <p className="text-[#64748B] max-w-2xl mx-auto">
              Every land parcel in our portfolio undergoes a rigorous legal and technical audit 
              by our in-house panel of estate experts to ensure your investment is safe.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm mb-4">
                <Gavel className="text-[#45A301]" size={30} />
              </div>
              <p className="font-bold text-gray-800">Legal Land Audit</p>
              <p className="text-xs text-gray-500 mt-2 leading-relaxed">Clear title deed history checked for the last 30 years.</p>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm mb-4">
                <Map className="text-[#45A301]" size={30} />
              </div>
              <p className="font-bold text-gray-800">Land Survey</p>
              <p className="text-xs text-gray-500 mt-2 leading-relaxed">Physical boundary mapping using high-precision DGPS technology.</p>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm mb-4">
                <FileCheck className="text-[#45A301]" size={30} />
              </div>
              <p className="font-bold text-gray-800">Pattayam Verify</p>
              <p className="text-xs text-gray-500 mt-2 leading-relaxed">Direct authentication from Village, Taluk & Registrar offices.</p>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm mb-4">
                <Landmark className="text-[#45A301]" size={30} />
              </div>
              <p className="font-bold text-gray-800">Tax Status</p>
              <p className="text-xs text-gray-500 mt-2 leading-relaxed">Up-to-date Land Tax (Kist) and encumbrance certificate (EC) check.</p>
            </div>
          </div>
        </div>

        {/* DOCUMENT MODAL */}
        {openDoc && (
          <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
            <div className="bg-white rounded-2xl p-8 w-full max-w-lg relative shadow-2xl">
              <button
                onClick={() => setOpenDoc(null)}
                className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full transition"
              >
                <X size={24} />
              </button>
              <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-[#eef2e6] rounded-xl">
                  <FileCheck className="text-[#45A301]" size={28} />
                </div>
                <div>
                  <h3 className="text-xl font-bold">Document Details</h3>
                  <p className="text-sm text-gray-500">Legal Paper Information</p>
                </div>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl border border-dashed border-gray-300">
                <p className="text-gray-700 font-medium text-center text-lg italic">
                  "{openDoc}"
                </p>
              </div>
              <p className="mt-6 text-xs text-gray-400 text-center uppercase tracking-widest">
                Verified by KL Property Audit Team
              </p>
            </div>
          </div>
        )}
      </div>

      <RequestVisitModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        propertyId={data?._id}
      />
    </div>
  );
};

// Sub-component for Land Specifications
function Spec({ label, value }) {
  if (!value) return null; 

  return (
    <div className="border-b border-gray-50 pb-4">
      <p className="text-xs text-[#94A3B8] uppercase font-bold tracking-tighter mb-1">{label}</p>
      <p className="text-base md:text-lg font-semibold text-gray-800">
        {value}
      </p>
    </div>
  );
}

export default PropertyOverview;